import React from "react";

export default function Banner() {
    return (
        <div style={{ marginTop: 100 }}>
            <div className="container w-100">
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-5">
                        <div className="photo_box"></div>
                    </div>
                    <div className="col-md-8 col-sm-12 mb-5">
                        <div class="banner_text">
                            <h2>Joseph Samuel </h2>
                            <p>Web and Mobile App Developer</p>
                            <a href="#about" class="btn read_more_btn">
                                read more
                            </a>
                            <div class="mt-5">
                                <a href="https://facebook.com/Coolheaded8">
                                    <i class="fa fa-facebook" id="fafa2"></i>
                                </a>
                                &nbsp;&nbsp;
                                <a href="https://twitter.com/coolheaded8">
                                    <i class="fa fa-twitter" id="fafa2"></i>
                                </a>
                                &nbsp;&nbsp;
                                <a href="https://github.com/coolheaded1">
                                    <i class="fa fa-github" id="fafa2"></i>
                                </a>
                                &nbsp;&nbsp;
                                <a href="https://wa.me/+2349030306779">
                                    <i class="fa fa-whatsapp" id="fafa2"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="main_banner">
        <div class="banner_text">
          <h2>I'm Samuel Joseph</h2>
          <p>A front-End developer</p>
          <button class="btn read_more_btn">read more</button>
          <div class="mt-5">
            <a href="https://facebook.com/Coolheaded8">
              <i class="fa fa-facebook" id="fafa2"></i>
            </a>
            &nbsp;&nbsp;
            <a href="https://twitter.com/coolheaded8">
              <i class="fa fa-twitter" id="fafa2"></i>
            </a>
            &nbsp;&nbsp;
            <a href="https://github.com/coolheaded1">
              <i class="fa fa-github" id="fafa2"></i>
            </a>
            &nbsp;&nbsp;
            <a href="https://wa.me/+2349030306779">
              <i class="fa fa-whatsapp" id="fafa2"></i>
            </a>
          </div>
        </div>
        <div className="banner"></div>
      </div> */}
        </div>
    );
}
